import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import Home from './pages/Home';
import Portfolio from './pages/Portfolio';
import Orcamento from './pages/Orcamento';
import Obrigado from './pages/Obrigado';
import PoliticaPrivacidade from './pages/PoliticaPrivacidade';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/orcamento" element={<Orcamento />} />
          <Route path="/obrigado" element={<Obrigado />} />
          <Route path="/politica-de-privacidade" element={<PoliticaPrivacidade />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
